import { render, staticRenderFns } from "./forgetPsd.vue?vue&type=template&id=ed441ca4&"
import script from "./forgetPsd.vue?vue&type=script&lang=js&"
export * from "./forgetPsd.vue?vue&type=script&lang=js&"
import style0 from "./forgetPsd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports